// extracted by mini-css-extract-plugin
export var button = "TagList-module--button--bace9";